/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _wheelDirection = __webpack_require__(1);

var _wheelDirection2 = _interopRequireDefault(_wheelDirection);

var _isPreventTime = __webpack_require__(2);

var _isPreventTime2 = _interopRequireDefault(_isPreventTime);

var _intro = __webpack_require__(3);

var _intro2 = _interopRequireDefault(_intro);

var _partOne = __webpack_require__(4);

var _partOne2 = _interopRequireDefault(_partOne);

var _partTwo = __webpack_require__(5);

var _partTwo2 = _interopRequireDefault(_partTwo);

var _sand = __webpack_require__(6);

var _sand2 = _interopRequireDefault(_sand);

var _Update = __webpack_require__(7);

var _Update2 = _interopRequireDefault(_Update);

var _Event = __webpack_require__(8);

var _Event2 = _interopRequireDefault(_Event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var intro = new _intro2.default();
var partOne = new _partOne2.default();
var partTwo = new _partTwo2.default();
var sand = new _sand2.default();
var update = new _Update2.default();
var event = new _Event2.default();

var page = { intro: intro, partOne: partOne, partTwo: partTwo, sand: sand, update: update, event: event };
var context = $('.section-page');
var nowCount = 0;
var maxCount = 9;
var currentPage = ['intro', 'intro1'];
var DOM_MovieLayer = $('.layer-movie');

var setPage = function setPage(direction) {
    if (nowCount + direction < 0 || nowCount + direction > maxCount) return;
    nowCount = nowCount + direction;

    render(nowCount);
};

var render = function render(renderId) {
    var go = void 0,
        id = void 0;

    var _pageMap = pageMap(renderId);

    var _pageMap2 = _slicedToArray(_pageMap, 2);

    go = _pageMap2[0];
    id = _pageMap2[1];


    var query = go + id;

    if (currentPage) {
        page[currentPage[0]].reset(currentPage[1]);
    }

    setNaviActive(query);

    page[go].start(query);
    currentPage = [go, query];
};

var setNaviActive = function setNaviActive(query) {
    $('.nav-list a').removeClass('active');

    switch (query) {
        case 'partOne1':
        case 'partOne2':
            $('[href="#page-part1"]').addClass('active');
            break;
        case 'partTwo1':
        case 'partTwo2':
            $('[href="#page-part2"]').addClass('active');
            break;
        case 'sand1':
        case 'sand2':
            $('[href="#page-sand"]').addClass('active');
            break;
        case 'update1':
        case 'update2':
            $('[href="#page-update"]').addClass('active');
            break;
        case 'event1':
            $('[href="#page-event"]').addClass('active');
            break;
    }
};

var pageMap = function pageMap(value) {
    var map = {
        0: ['intro', 1],
        1: ['partOne', 1],
        2: ['partOne', 2],
        3: ['partTwo', 1],
        4: ['partTwo', 2],
        5: ['sand', 1],
        6: ['sand', 2],
        7: ['update', 1],
        8: ['update', 2],
        9: ['event', 1]
    };

    return map[value];
};

var naviMap = function naviMap(value) {
    var map = {
        '#page-intro': 0,
        '#page-part1': 1,
        '#page-part2': 3,
        '#page-sand': 5,
        '#page-update': 7,
        '#page-event': 9
    };
    return map[value];
};

$(document).on('click', '.btn-link-index', function (e) {
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

$(document).on('click', '.nav-list a', function (e) {
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

nc.ui.Player.movieLayer = new nc.ui.Player({
    selector: '#movie-box',
    videoId: 'GyGKpAo8Wz0',
    mute: false,
    controls: true
});

$(document).on('click', '.btn-link-play', function (e) {
    e.preventDefault();
    DOM_MovieLayer.fadeIn();
    nc.ui.Player.movieLayer.play();
    $(window).trigger('resize');
});

$(document).on('click', '.layer-movie .btn-close', function (e) {
    e.preventDefault();
    nc.ui.Player.movieLayer.stop();
    DOM_MovieLayer.fadeOut();
});

context.on('mousewheel DOMMouseScroll', function (e) {
    e.stopPropagation();
    if ((0, _isPreventTime2.default)(window.lastWheelTime)) return;
    window.lastWheelTime = new Date().getTime();

    setPage((0, _wheelDirection2.default)(e));
});

new nc.ui.Preloader({
    'resourcePath': '/promo/bns/history/2017/170913_taecheon',
    'delay': 500,
    'preLoadList': ['/img/update/bg-update.jpg', '/img/update/obj4-ch1.png', '/img/update/obj4-ch2.png', '/img/update/obj4-dis1.png', '/img/update/obj4-dis2.png', '/img/update/obj4-img1.png', '/img/update/obj4-img2.png', '/img/update/obj4-tit.png', '/img/update/obj4-txt1.png', '/img/update/obj4-txt2.png', '/img/sand/obj3-ch1-off.png', '/img/sand/obj3-ch1.png', '/img/sand/obj3-ch2-off.png', '/img/sand/obj3-ch2.png', '/img/sand/obj3-dis1.png', '/img/sand/obj3-dis2.png', '/img/sand/obj3-tit.png', '/img/sand/obj3-txt1.png', '/img/sand/obj3-txt2.png', '/img/part2/obj2-ch1-off.png', '/img/part2/obj2-ch1.png', '/img/part2/obj2-ch2-off.png', '/img/part2/obj2-ch2.png', '/img/part2/obj2-dis1.png', '/img/part2/obj2-tit.png', '/img/part2/obj2-txt1.png', '/img/part2/obj2-txt2.png', '/img/part1/obj1-ch1-off.png', '/img/part1/obj1-ch1.png', '/img/part1/obj1-ch2-off.png', '/img/part1/obj1-ch2.png', '/img/part1/obj1-dis1.png', '/img/part1/obj1-dis2.png', '/img/part1/obj1-tit.png', '/img/part1/obj1-txt1.png', '/img/part1/obj1-txt2.png', '/img/intro/bg-arrow.png', '/img/intro/bg-back.jpg', '/img/intro/btn-play.png', '/img/intro/circle.png', '/img/intro/obj0-ch2.png', '/img/intro/obj0-tit.png', '/img/intro/obj0-txt1.png', '/img/intro/obj0-txt4.png', '/img/intro/txt-scroll.png', '/img/event/bg-event.jpg', '/img/event/obj5-card1.png', '/img/event/obj5-card2.png', '/img/event/obj5-clip3.png', '/img/event/obj5-clip4.png', '/img/event/obj5-state.png', '/img/event/obj5-tit.png', '/img/common/bet.png', '/img/common/bg-bottom.png', '/img/common/bg-cover.png', '/img/common/bg-fog.png', '/img/common/bg-footer.png', '/img/common/bg-logo.png', '/img/common/bg-menu.png', '/img/common/bg-nav.png', '/img/common/bg-util.png', '/img/common/bg-video.png', '/img/common/btn_close.png', '/img/common/sns.jpg'],
    'devName': 'bns'
});

$(document).on('preLoaded', function () {
    $('.container').show();
    page['intro'].start('intro1');
    $(window).resize();
    $('.header').addClass('animate');
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function WheelDirection(e) {
    if (e.type === 'DOMMouseScroll') return e.originalEvent.detail > 0 ? 1 : -1;
    if (e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY > 0 ? -1 : 1;
    return e.originalEvent.wheelDelta > 0 ? -1 : 1;
}

exports.default = WheelDirection;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function isPreventTime(diffTime) {
    var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1200;

    return new Date().getTime() - diffTime < to;
}

exports.default = isPreventTime;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Intro = function () {
    function Intro() {
        _classCallCheck(this, Intro);

        this.context = null;
        this.pageActive = {};

        TweenMax.to('.circle1', 0, { scale: 0, opacity: 1, ease: Power0.easeNone, onComplete: function onComplete() {
                TweenMax.to('.circle1', 3, { scale: 2, opacity: 0, repeat: -1, ease: Power0.easeNone });
            } });

        TweenMax.to('.circle2', 0, { delay: 1.5, scale: 0, opacity: 1, ease: Power0.easeNone, onComplete: function onComplete() {
                TweenMax.to('.circle2', 3, { scale: 2, opacity: 0, repeat: -1, ease: Power0.easeNone });
            } });

        TweenMax.to('.obj0-box', 3, { delay: 2, top: -5, yoyo: true, repeat: -1, ease: Power0.easeNone });
    }

    _createClass(Intro, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
        }
    }, {
        key: 'intro1',
        value: function intro1() {
            this.context = $('.section-page__intro');
            this.context.addClass('animate-intro');
        }
    }]);

    return Intro;
}();

exports.default = Intro;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PartOne = function () {
    function PartOne() {
        _classCallCheck(this, PartOne);

        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }

    _createClass(PartOne, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            var _this = this;

            this.pageActive[page] = false;
            this.context.removeClass('animate-in animate-1 animate-2');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');

            setTimeout(function () {
                var id = $('.animate-in').attr('id');

                if (!_this.pageActive[page]) {
                    if (id === 'page-part1') {
                        return;
                    }

                    _this.videoBg.part1 && _this.videoBg.part1.stop();
                }
            }, 1000);
        }
    }, {
        key: 'partOne1',
        value: function partOne1() {
            this.context = $('.section-page__part1');
            this.context.addClass('animate-in animate-1');

            this.context.find('.obj1-ch1').addClass('active');
            this.context.find('.obj1-txt1').addClass('active');

            if (!this.videoBg.part1.player.state.isPlay) {
                this.playBg('part1');
            }
        }
    }, {
        key: 'partOne2',
        value: function partOne2() {
            this.context = $('.section-page__part1');
            this.context.addClass('animate-in  animate-2');

            this.context.find('.obj1-ch2').addClass('active');
            this.context.find('.obj1-txt2').addClass('active');

            if (!this.videoBg.part1.player.state.isPlay) {
                this.playBg('part1');
            }
        }
    }, {
        key: 'setBg',
        value: function setBg() {
            this.videoBg.part1 = new nc.ui.Player({
                selector: '#bg-video-part1',
                videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/update/201709/02_UPDATE_LOW.mp4',
                mute: true,
                autoPlay: false,
                loop: true
            });
        }
    }, {
        key: 'playBg',
        value: function playBg(id) {
            var _this2 = this;

            if (this.videoBgReady[id]) {
                this.videoBg[id].play();
                return;
            }

            var checkReady = setInterval(function () {
                _this2.videoBgReady[id] = _this2.videoBg[id].player.state.isReady;
                if (_this2.videoBgReady[id]) {
                    _this2.videoBg[id].play();
                    clearInterval(checkReady);
                }
            }, 100);
        }
    }]);

    return PartOne;
}();

exports.default = PartOne;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PartTwo = function () {
    function PartTwo() {
        _classCallCheck(this, PartTwo);

        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }

    _createClass(PartTwo, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            var _this = this;

            this.pageActive[page] = false;
            this.context.removeClass('animate-in animate-1 animate-2');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');

            setTimeout(function () {
                var id = $('.animate-in').attr('id');

                if (!_this.pageActive[page]) {
                    if (id === 'page-part2') {
                        return;
                    }

                    _this.videoBg.part1 && _this.videoBg.part1.stop();
                }
            }, 1000);
        }
    }, {
        key: 'partTwo1',
        value: function partTwo1() {
            this.context = $('.section-page__part2');
            this.context.addClass('animate-in animate-1');

            this.context.find('.obj2-ch1').addClass('active');
            this.context.find('.obj2-txt1').addClass('active');

            if (!this.videoBg.part1.player.state.isPlay) {
                this.playBg('part1');
            }
        }
    }, {
        key: 'partTwo2',
        value: function partTwo2() {
            this.context = $('.section-page__part2');
            this.context.addClass('animate-in animate-2');

            this.context.find('.obj2-ch2').addClass('active');
            this.context.find('.obj2-txt2').addClass('active');

            if (!this.videoBg.part1.player.state.isPlay) {
                this.playBg('part1');
            }
        }
    }, {
        key: 'setBg',
        value: function setBg() {
            this.videoBg.part1 = new nc.ui.Player({
                selector: '#bg-video-partTwo1',
                videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/update/201709/05_UPDATE_LOW.mp4',
                mute: true,
                autoPlay: false,
                loop: true
            });
        }
    }, {
        key: 'playBg',
        value: function playBg(id) {
            var _this2 = this;

            if (this.videoBgReady[id]) {
                this.videoBg[id].play();
                return;
            }

            var checkReady = setInterval(function () {
                _this2.videoBgReady[id] = _this2.videoBg[id].player.state.isReady;
                if (_this2.videoBgReady[id]) {
                    _this2.videoBg[id].play();
                    clearInterval(checkReady);
                }
            }, 100);
        }
    }]);

    return PartTwo;
}();

exports.default = PartTwo;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sand = function () {
    function Sand() {
        _classCallCheck(this, Sand);

        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }

    _createClass(Sand, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            var _this = this;

            this.pageActive[page] = false;
            this.context.removeClass('animate-in animate-1 animate-2');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');

            setTimeout(function () {
                if (!_this.pageActive[page]) {
                    _this.videoBg[page] && _this.videoBg[page].stop();
                }
            }, 1000);
        }
    }, {
        key: 'sand1',
        value: function sand1() {
            this.context = $('.section-page__sand');
            this.context.addClass('animate-in animate-1');

            this.context.find('.obj3-ch1').addClass('active');
            this.context.find('.obj3-txt1').addClass('active');

            this.playBg('sand1');
        }
    }, {
        key: 'sand2',
        value: function sand2() {
            this.context = $('.section-page__sand');
            this.context.addClass('animate-in animate-2');

            this.context.find('.obj3-ch2').addClass('active');
            this.context.find('.obj3-txt2').addClass('active');

            this.playBg('sand2');
        }
    }, {
        key: 'setBg',
        value: function setBg() {
            this.videoBg.sand1 = new nc.ui.Player({
                selector: '#bg-video-sand1',
                videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/update/201709/03_UPDATE_LOW.mp4',
                mute: true,
                autoPlay: false,
                loop: true
            });
            this.videoBg.sand2 = new nc.ui.Player({
                selector: '#bg-video-sand2',
                videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/update/201709/04_UPDATE_LOW.mp4',
                mute: true,
                autoPlay: false,
                loop: true
            });
        }
    }, {
        key: 'playBg',
        value: function playBg(id) {
            var _this2 = this;

            if (this.videoBgReady[id]) {
                this.videoBg[id].play();
                return;
            }

            var checkReady = setInterval(function () {
                _this2.videoBgReady[id] = _this2.videoBg[id].player.state.isReady;
                if (_this2.videoBgReady[id]) {
                    _this2.videoBg[id].play();
                    clearInterval(checkReady);
                }
            }, 100);
        }
    }]);

    return Sand;
}();

exports.default = Sand;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Update = function () {
    function Update() {
        _classCallCheck(this, Update);

        this.context = null;
        this.pageActive = {};
    }

    _createClass(Update, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in animate-1 animate-2');
            this.context.addClass('animate-out');
            this.context.find('.active').removeClass('active');
        }
    }, {
        key: 'update1',
        value: function update1() {
            this.context = $('.section-page__update');
            this.context.addClass('animate-in animate-1');
            this.context.find('.obj4-clip1').addClass('active');
        }
    }, {
        key: 'update2',
        value: function update2() {
            this.context = $('.section-page__update');
            this.context.addClass('animate-in animate-2');
            this.context.find('.obj4-clip2').addClass('active');
        }
    }]);

    return Update;
}();

exports.default = Update;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Event = function () {
    function Event() {
        _classCallCheck(this, Event);

        this.context = null;
        this.pageActive = {};
    }

    _createClass(Event, [{
        key: 'start',
        value: function start(page) {
            this.pageActive[page] = true;
            this[page]();
            this.context.removeClass('animate-out');
        }
    }, {
        key: 'reset',
        value: function reset(page) {
            this.pageActive[page] = false;
            this.context.removeClass('animate-in');
            this.context.addClass('animate-out');
        }
    }, {
        key: 'event1',
        value: function event1() {
            this.context = $('.section-page__event');
            this.context.addClass('animate-in');
        }
    }]);

    return Event;
}();

exports.default = Event;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js